import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AbstractRestService } from 'src/app/core/services/AbstractRestService';
import { IDictionaryValue } from '@cinetixx/cinetixx-ui';
import { IConfigurationPayload, ISeatsPlan } from '../../interfaces';
import { CreatorStateService } from '../app-services';

@Injectable({
  providedIn: 'root'
})
export class SectorsConfigurationsApiService extends AbstractRestService<ISeatsPlan> {

  protected get basePath(): string {
    return `/auditoriums/sectors`;
  };

  public saveConfiguration(sectorId: number, payload: IConfigurationPayload): Observable<IDictionaryValue[]> {
    return this.apiService.post(`${this.basePath}/${sectorId}/configurations`, payload).pipe(
      tap((res) => CreatorStateService.pickedConfiguration = res),
      switchMap(() => this.getAllSectorsConfigurations(sectorId)),
    );
  }

  public updateConfiguration(sectorId: number, configurationId: number, payload: Pick<IConfigurationPayload, 'seats'>): Observable<IDictionaryValue[]> {
    return this.apiService.put(`${this.basePath}/${sectorId}/configurations/${configurationId}`, payload).pipe(
      switchMap(() => this.getAllSectorsConfigurations(sectorId)),
    );
  }

  public getHasConfigurationPlannedShows(sectorId: number, configurationId: number): Observable<boolean> {
    return this.apiService.get(`${this.basePath}/${sectorId}/configurations/${configurationId}/has-planned-shows`).pipe(
      tap(value => CreatorStateService.hasPlannedShows = value)
    );
  }

  public getAllSectorsConfigurations(sectorId: number): Observable<IDictionaryValue[]> {
    if (!sectorId) {
      return of([]);
    }

    return this.apiService.get(`${this.basePath}/${sectorId}/configurations/all`).pipe(
      tap(configurations => CreatorStateService.configurations = configurations),
    );
  }

  public deleteConfiguration(sectorId: number, configurationId: number): Observable<IDictionaryValue[]> {
    return this.apiService.delete(`${this.basePath}/${sectorId}/configurations/${configurationId}`).pipe(
      switchMap(() => this.getAllSectorsConfigurations(sectorId)),
    );
  }
}
